module.exports = __webpack_public_path__ + "img/decor2.0e0bb7e2.svg";